<link rel="ractive" href="./periods-dropdown.html" name="c-periods-dropdown">

<div class="c-package-sidemenu">
	<div class="package-stats {{tabRoute === 'stats' ? 'move-top' : ''}}">
		{{#unless tabRoute === 'stats' && type !== 'npm'}}
		<div class="block-shadow {{tabRoute === 'files' ? 'bottom' : tabRoute === 'stats' ? 'top' : ''}}"></div>
		{{/unless}}

		<div style="position: relative; z-index: 1;{{#unless tabRoute !== 'stats'}}display: none;{{/unless}}">
			<div class="sidemenu-title">
				<span>Statistics</span>

				<c-periods-dropdown selectedValue="{{periodData.periodValue}}" selectHandler="{{@this.handlePeriodSelecting()}}"></c-periods-dropdown>
			</div>

			<div class="horizontal-divider"></div>

			<div class="stats-section mb-18">
				<span>Requests</span>
				<span>{{noDataOfRequests ? 'No data' : _.formatNumber(requestsTotal)}}</span>
			</div>

			<div class="requests-chart-wrapper">
				{{#if noDataOfRequests}}
					<img src="{{@shared.assetsHost}}/img/no-data-chart-side.svg" class="empty-chart" width="294" height="56">
				{{else}}
					<canvas id="requests-chart"></canvas>
				{{/if}}
			</div>

			{{#if tabRoute === 'readme' || type === 'npm'}}
			<div class="horizontal-divider"></div>

			<div class="stats-section mb-18">
				<span>Bandwidth</span>
				<span>{{#if noDataOfBandwidth}}No data{{else}}{{_.formatNumber(bandwidthTotal)}} {{bandwidthUnit}}{{/if}}</span>
			</div>

			<div class="bandwidth-chart-wrapper">
				{{#if noDataOfBandwidth}}
					<img src="{{@shared.assetsHost}}/img/no-data-chart-side.svg" class="empty-chart" width="294" height="56">
				{{else}}
					<canvas id="bandwidth-chart"></canvas>
				{{/if}}
			</div>

			<div class="horizontal-divider"></div>
			{{/if}}
		</div>

		{{#if tabRoute === 'readme' || type === 'npm'}}
		<div class="stats-section mb-24">
			<!-- show package version if no data of top versions -->
			<span>Top version - {{noDataOfVersions ? package.version : topVersion}}</span>
			<span>{{#if noDataOfVersions}}No data{{else}}{{_.formatNumber(topVersionHits)}}{{/if}}</span>
		</div>
		{{/if}}

		{{#if tabRoute !== "files"}}
			{{#if tabRoute === 'readme' || type === 'npm'}}
			<a on-click="@this.set('tabRoute', 'stats')" class="btn-secondary">Full {{name}} Download Stats</a>
			{{/if}}

			{{#unless noDataOfVersions}}
				{{#if tabRoute === 'readme' || type === 'npm'}}
				<div class="horizontal-divider"></div>
				{{/if}}

				<div class="twitter-share">
					<div>
						{{#if packageRank}}
							The {{_.nth(packageRank)}} most popular on jsDelivr
						{{/if}}
					</div>
					<a class="btn-twitter-share mt-8"
						target="_blank"
						rel="noopener noreferrer"
						href="https://twitter.com/intent/tweet?text={{encodeURIComponent(`${name} is the ${_.nth(packageRank)} most popular package on @jsDelivr CDN, with ${_.formatNumber(requestsTotal)} hits ${twitterPeriodPartText}: ${~/link}`)}}">
						<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/twitter-white.svg">
						Share
					</a>
				</div>
			{{/unless}}

			{{#if package.keywords}}
				<div class="stats-keywords mt-32">
					<div class="stats-keywords-header">Keywords</div>
					<div class="stats-keywords-badges {{#if tabRoute === 'stats'}}shortened{{/if}}">
						{{#each package.keywords}}
							<div class="keyword-badge">{{this}}</div>
						{{/each}}
						{{#if true === 'stats'}}
							<div class="badge-cover"></div>
						{{/if}}
					</div>
				</div>
			{{/if}}
		{{/if}}
	</div>

	{{#if tabRoute !== "files"}}
		<div class="box-badge mt-32 mb-32">
			<div class="box-title">Get a badge for your package</div>
			<img src="https://data.jsdelivr.com/v1/package/{{~/type || 'npm'}}/{{name}}/badge{{#if ~/badgeAltStyle}}?style=rounded{{/if}}">
			<img as-clipboard="'Copy markdown to clipboard'"
				data-clipboard-text="[![](https://data.jsdelivr.com/v1/package/{{~/type}}/{{~/name}}/badge{{#if ~/badgeAltStyle}}?style=rounded{{/if}})](https://www.jsdelivr.com/package/{{~/type}}/{{~/name}})"
				width="20"
				height="20"
				src="{{@shared.assetsHost}}/img/icons/copy-btn-black.svg">
			<img as-tooltip="'Alternate badge style'"
				on-click="@this.toggle('badgeAltStyle')"
				width="20"
				height="20"
				src="{{@shared.assetsHost}}/img/icons/alternate-btn.svg">
		</div>
	{{/if}}
</div>


<script>
	const _ = require('../../assets/js/_');
	const clipboard = require('../../assets/js/decorators/clipboard');
	const tooltip = require('../../assets/js/decorators/tooltip');
	const http = require('../../assets/js/utils/http');
	const initCharts = require('../../assets/js/utils/charts');

	component.exports = {
		computed: {
			barThickness () {
				switch (this.get('periodData').periodType) {
					case 's-quarter':
						return 2;

					case 's-year':
						return 1;

					default:
						return 4;
				}
			},
			usageChartGroupBy () {
				switch (this.get('periodData').periodType) {
					default:
						return 'day';
				}
			},
		},
		data () {
			return {
				_,
				periodData: { periodText: 'month', periodValue: 'month', periodType: 's-month' },
				noDataOfRequests: false,
				noDataOfBandwidth: false,
				noDataOfVersions: false,
				topVersionHits: 0,
				bandwidthTotal: 0,
				requestsTotal: 0,
				twitterPeriodPartText: '',
			};
		},
		decorators: {
			clipboard,
			tooltip,
		},
		oninit () {
			if (!Ractive.isServer) {
				this.set('link', this.get('@global.location.href'));

				this.observe('periodData.periodValue', (periodValue) => {
					if (periodValue) {
						let type = this.get('type');
						let name = this.get('name');

						// get overall package stats (hits-bandwidth data for charts, hits rank of package)
						http.fetchPackageSummaryStats(type, name, periodValue).then((response) => {
							this.animate('packageRank', response.hits.rank + 1, { duration: 1000 });

							if (response.hits.total) {
								this.set('noDataOfRequests', false);
								this.set('packageDateStats', response.hits);
								this.animate('requestsTotal', response.hits.total, { duration: 1000 });
							} else {
								this.set('noDataOfRequests', true);
							}

							if (response.bandwidth.total) {
								this.set('noDataOfBandwidth', false);
								this.set('packageBandwidthStats', response.bandwidth);
								this.set('bandwidthUnit', _.findUnitFromNumber(response.bandwidth.total));
								this.animate('bandwidthTotal', _.convertBytesToUnits(response.bandwidth.total, this.get('bandwidthUnit')), { duration: 1000 });
							} else {
								this.set('noDataOfBandwidth', true);
							}
						});

						// get package top version stats
						http.fetchPackageVersionsStats(type, name, periodValue, 'hits').then((response) => {
							if (!response.length) {
								this.set('noDataOfVersions', true);
								return;
							}

							this.set('topVersion', response[0].version);
							this.animate('topVersionHits', response[0].hits.total, { duration: 1000 });
						});
					}
				});

				this.observe('periodData.periodText', (periodText) => {
					let twitterPeriodPartText = 'in the ';

					if (periodText === 'month' || periodText === 'quarter' || periodText === 'year') {
						twitterPeriodPartText += 'last ';
					}

					twitterPeriodPartText += periodText;

					this.set('twitterPeriodPartText', twitterPeriodPartText);
				});

				initCharts().then(({ createBarChart }) => {
					this.observe('packageDateStats tabRoute', () => {
						if (this.get('tabRoute') === 'stats') {
							return null;
						}

						let packageDateStats = this.get('packageDateStats');
						let chartPeriodType = this.get('periodData').periodType;
						let usageChartGroupBy = this.get('usageChartGroupBy');

						if (!packageDateStats) {
							return null;
						}

						let {
							values,
							labels,
							valueUnits,
						} = _.getPreparedDataForBarChart(packageDateStats, usageChartGroupBy, chartPeriodType, false);

						// temp solution to fix chart recreation after switching from stats tab
						setTimeout(() => {
							let requestsChart = this.get('requestsChart');

							if (requestsChart) {
								requestsChart.destroy();
								this.set('requestsChart', null);
							}

							let chartEl = this.find('#requests-chart');
							let chartData = {
								labels,
								datasets: [{
									data: values,
									borderWidth: 0,
									barThickness: this.get('barThickness'),
									hoverBackgroundColor: '#F65128',
									borderRadius: 1,
								}],
								valueUnits,
							};
							let chartSettings = {
								useExternalTooltip: true,
								externalTooltipId: 'packageSidemenuRequestsChartTooltip',
								externalTooltipVerticalOffset: 40,
							};
							let chartConfig = {
								options: {
									scales: {
										x: {
											display: false,
										},
										y: {
											display: false,
										},
									},
								},
							};

							requestsChart = createBarChart(chartEl, chartData, chartSettings, chartConfig);

							this.set('requestsChart', requestsChart);
						}, 100);
					});

					this.observe('packageBandwidthStats tabRoute', () => {
						if (this.get('tabRoute') === 'stats') {
							return null;
						}

						let packageBandwidthStats = this.get('packageBandwidthStats');
						let chartPeriodType = this.get('periodData').periodType;
						let usageChartGroupBy = this.get('usageChartGroupBy');

						if (!packageBandwidthStats) {
							return null;
						}

						let {
							values,
							labels,
							valueUnits,
						} = _.getPreparedDataForBarChart(packageBandwidthStats, usageChartGroupBy, chartPeriodType, true);

						// temp solution to fix chart recreation after switching from stats tab
						setTimeout(() => {
							let bandwidthChart = this.get('bandwidthChart');

							if (bandwidthChart) {
								bandwidthChart.destroy();
								this.set('bandwidthChart', null);
							}

							let chartEl = this.find('#bandwidth-chart');
							let chartData = {
								labels,
								datasets: [{
									data: values,
									borderWidth: 0,
									barThickness: this.get('barThickness'),
									hoverBackgroundColor: '#F65128',
									borderRadius: 1,
								}],
								valueUnits,
							};
							let chartSettings = {
								useExternalTooltip: true,
								externalTooltipId: 'packageSidemenuBandwidthChartTooltip',
								externalTooltipVerticalOffset: 40,
							};
							let chartConfig = {
								options: {
									scales: {
										x: {
											display: false,
										},
										y: {
											display: false,
										},
									},
								},
							};

							bandwidthChart = createBarChart(chartEl, chartData, chartSettings, chartConfig);

							this.set('bandwidthChart', bandwidthChart);
						}, 100);
					});
				});
			}
		},
		handlePeriodSelecting () {
			return (periodData) => {
				this.set('periodData', periodData);
			};
		},
	};
</script>
